import styled from 'styled-components'
import { Spin as sp } from 'antd'

export const Spin = styled(sp)`
  margin: 20px 0;
  margin-bottom: 20px;
  padding: 30px 50px;
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
`

export const SpinWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 80px;
`
